<template>
  <PageLayout
    :page-title="itemTitle"
    :breadcrumb="pageTitle"
    :breadcrumb-to="mode === 'case' ? '/case/' : '/solution/'"
    banner-key="solution"
  >
    <div class="case-page" v-if="item.id || item.itemName">
      <div class="case-page__inner wrap">
        <CaseIndustryNav
          :mode="mode"
          :active-slug="solutionSlug"
          :active-sub-slug="subSlug"
          :active-sub-id="id"
        />

        <article class="case-detail">
          <header class="case-detail__head">
            <router-link :to="listLink" class="case-detail__back">
              <i class="font_family icon-zuojiantou"></i>
              {{ $t('common.backToList') }}
            </router-link>
            <h1 class="case-detail__title">{{ itemTitle || $t('nav.applications') }}</h1>
          </header>

          <!-- 1. 文字 -->
          <div class="case-detail__content" v-html="bodyHtml"></div>

          <!-- 2. 图片 -->
          <div v-if="hasImage" class="case-detail__media case-detail__media--image">
            <img :src="displayImage" :alt="itemTitle">
          </div>

          <!-- 3. 视频（跨浏览器兼容播放） -->
          <div v-if="rawVideoUrl" class="case-detail__media case-detail__media--video is-video">
            <CompatibleVideo
              :src="rawVideoUrl"
              video-class="case-detail__video"
              :controls="true"
              preload="metadata"
              @loadedmetadata="onVideoReady"
              @play="onVideoReady"
            />
          </div>
        </article>
      </div>
    </div>
  </PageLayout>
</template>

<script>
import PageLayout from '@/components/hirays/PageLayout.vue'
import CaseIndustryNav from '@/components/hirays/CaseIndustryNav.vue'
import CompatibleVideo from '@/components/hirays/CompatibleVideo.vue'
import { getSolutionItem } from '@/utils/http'
import { unwrapData, resolveImageUrl, stripHtml } from '@/utils/content'
import { resolveCmsImageUrl } from '@/utils/media'

export default {
  components: { PageLayout, CaseIndustryNav, CompatibleVideo },
  props: {
    solutionSlug: { type: String, default: '' },
    id: { type: [String, Number], default: '' },
    mode: { type: String, default: 'case' }
  },
  data() {
    return {
      item: {},
      subSlug: ''
    }
  },
  computed: {
    pageTitle() {
      return this.mode === 'case' ? this.$t('nav.applications') : this.$t('nav.solutions')
    },
    listLink() {
      const base = this.mode === 'case' ? '/case/' : '/solution/'
      return base + this.solutionSlug + '/'
    },
    itemTitle() {
      return this.$cleanBrand(this.item.itemName || '')
    },
    rawVideoUrl() {
      const raw = this.item.videoUrl || this.item.video_url || ''
      return resolveImageUrl(raw) || ''
    },
    hasImage() {
      return !!this.displayImage
    },
    displayImage() {
      return resolveCmsImageUrl(this.item.picUrl)
    },
    bodyHtml() {
      let raw = this.item.content || this.item.description || ''
      // Keep text here; hero image / video are rendered separately below
      raw = String(raw).replace(/<img\b[^>]*>/gi, '')
      const text = stripHtml(raw).trim()
      if (!text || text === this.itemTitle) {
        return '<p>' + (this.itemTitle || this.$t('common.noContent')) + '</p>'
      }
      return this.$cleanBrand(raw)
    }
  },
  watch: {
    id: { immediate: true, handler() { this.load() } }
  },
  methods: {
    reloadCmsData() {
      this.load()
    },

    onVideoReady(e) {
      const el = (e && e.target) || (this.$refs.caseVideo && this.$refs.caseVideo.$refs && this.$refs.caseVideo.$refs.video)
      if (!el) return
      try {
        el.muted = false
        el.defaultMuted = false
        el.volume = 1
      } catch (err) { /* ignore */ }
    },

    async load() {
      if (!this.id) return
      try {
        const res = await getSolutionItem(this.id)
        const data = unwrapData(res)
        this.item = data || {}
        this.subSlug = data && data.itemSlug ? data.itemSlug : ''
      } catch (e) {
        this.item = {}
      }
    }
  }
}
</script>
